import './index.less';
//# sourceMappingURL=index.js.map
